export default "__VITE_ASSET__BS35F_ox__"